export default __webpack_public_path__ + "static/low-code-development-cose-vantaggi-migliori-piattaforme-dc1bbdd49771e5cf67ad2c05ba16c363.jpg";